<template>
  <div class="editor-common-info">
    <div class="editor-common-info__block">
      <divider orientation="left">Общая информация</divider>
      <row :gutter="16">
        <i-col span="16">
          <div class="editor-common-info__status-row">
            <div>
              <span class="ms-help label">Шифр объекта</span>
              <i-input
                style="display: block"
                v-model="contract.code"
                placeholder="Например, ГСМ-19-ИГИ"
              />
            </div>
            <div style="margin-left: 16px">
              <span class="ms-help label">Номер договора</span>
              <i-input
                style="display: block"
                v-model="contract.number"
                placeholder="Например, 1040"
              />
            </div>
          </div>
        </i-col>
        <i-col span="8">
          <div class="editor-common-info__status">
            <span class="ms-help label">Статус</span>
            <i-select
              placeholder="Выберите статус"
              v-model="contract.contract_status_id"
            >
              <i-option
                v-for="item in statuses"
                :value="item.id"
                :key="item.id"
              >
                {{ item.name }}
              </i-option>
            </i-select>
          </div>
        </i-col>
      </row>
      <row>
        <i-col span="24">
          <div class="full-width-container">
            <span class="ms-help label">Наименование объекта</span>
            <i-input
              v-model="contract.name"
              type="textarea"
              :rows="5"
              placeholder="Строительство транспортного перехода через Керченский пролив"
            />
          </div>
        </i-col>
      </row>
      <row :gutter="16">
        <i-col span="12">
          <div class="full-width-container">
            <span class="ms-help label">Дата заключения договора</span>
            <date-picker
              format="dd.MM.yyyy"
              placeholder="Выберите дату"
              v-model="contract.sign_date"
            />
          </div>
        </i-col>
      </row>
      <row :gutter="16" style="margin-top: 12px">
        <i-col span="12">
          <span class="ms-help label">Менеджер проекта</span>
          <i-select
            class="editor-common-info__manager"
            placeholder="Выберите сотрудника"
            v-model="contract.manager_id"
            clearable
          >
            <i-option v-for="item in managers" :value="item.id" :key="item.id">
              {{ `${item.first_name} ${item.last_name}` }}
            </i-option>
          </i-select>
        </i-col>
        <i-col span="12">
          <span class="ms-help label">Полевой ГИП</span>
          <i-select
            class="editor-common-info__manager"
            placeholder="Выберите сотрудника"
            v-model="contract.field_manager_id"
            clearable
          >
            <i-option
              v-for="item in fieldManagers"
              :value="item.id"
              :key="item.id"
            >
              {{ `${item.first_name} ${item.last_name}` }}
            </i-option>
          </i-select>
        </i-col>
      </row>
    </div>

    <div class="editor-common-info__block">
      <divider orientation="left">Контрагенты</divider>
      <contragent-companies v-if="contract_id" :contract="contract" />
      <contract-companies v-else :contract="contract" />
    </div>

    <div class="editor-common-info__block">
      <divider orientation="left">Информация о видах работ</divider>
      <row :gutter="16">
        <i-col span="12">
          <i-select
            clearable
            placeholder="Выберите виды работ"
            v-model="contract.contract_job_types"
            multiple
          >
            <i-option v-for="item in jobTypes" :value="item.id" :key="item.id">
              {{ item.name }}
            </i-option>
          </i-select>
        </i-col>
      </row>
    </div>

    <div class="editor-common-info__block file-types" v-if="fileTypes.length">
      <divider orientation="left">Обязательные категории документов</divider>
      <row :gutter="16">
        <i-col span="12">
          <!-- <i-select
            clearable
            placeholder="Выберите категории"
            v-model="contract.mandatory_file_types"
            multiple
            :max-tag-count="1"
          >
            <i-option v-for="item in fileTypes" :value="item.id" :key="item.id">
              {{ item.name }}
            </i-option>
          </i-select> -->
          <contract-mandatory-files
            v-if="show"
            :contract="contract"
            :all-file-types="fileTypes"
          />
        </i-col>
        <i-col span="12">
          <div class="editor-common-info__original">
            <checkbox v-model="contract.is_original_exists">
              Оригиналы документов получены
            </checkbox>
          </div>
        </i-col>
      </row>
    </div>

    <div class="editor-common-info__block">
      <divider orientation="left">Специальный счет</divider>
      <row :gutter="16">
        <i-col span="12">
          <checkbox v-model="contract.spec_account">
            Спец. счет (статус)
          </checkbox>

          <div v-if="contract.spec_account" style="margin-top: 12px;">
            <span class="ms-help label">Наименование банка</span>
            <i-input
              v-model="contract.spec_account_bank"
              placeholder="Например, Альфа-банк"
            />
          </div>
        </i-col>
      </row>
    </div>
  </div>
</template>

<script>
import ContractCompanies from '../helpers/contracts-companies'
import ContragentCompanies from '../helpers/contragents-companies'
import ContractMandatoryFiles from '../helpers/contract-mandatory-files'
import { permissionsNames } from '@/config/permissions'

export default {
  props: ['contract', 'main-contract-id', 'show'],
  components: {
    ContractCompanies,
    ContragentCompanies,
    ContractMandatoryFiles
  },
  data () {
    return {
      statuses: [],
      jobTypes: [],
      managers: [],
      fieldManagers: [],
      roadmaps: [],
      loading: false,
      // contract_id: this.$route.query.contract_id || this.mainContractId,
      fileTypes: []
    }
  },
  computed: {
    contract_id () {
      return (
        this.$route.query.contract_id ||
        this.mainContractId ||
        (this.contract && this.contract.parent_id) ||
        undefined
      )
    }
  },
  methods: {
    async getUsers () {
      const config = {
        include: {
          position: {
            only: ['name']
          }
        }
      }
      const users = await this.$store.dispatch('GET_REQUEST', {
        url: `objectInfo/users?config=${JSON.stringify(config)}`
      })

      return users
    },
    getManagers (users) {
      return users.filter(
        u =>
          u.position &&
          u.position.name === permissionsNames.projectManagerPosition
      )
    },
    async getFieldManagers (users) {
      const url = 'page/field_manager'
      const fieldManagers = await this.$store.dispatch('GET_REQUEST', { url })

      return fieldManagers
    },
    async getContractJobTypes () {
      const config = {
        where: [
          {
            field: 'id',
            op: '=',
            value: this.contract_id
          }
        ],
        only: ['id'],
        include: { job_types: {} }
      }
      const url = `objectInfo/contracts?config=${JSON.stringify(config)}`
      const [data] = await this.$store.dispatch('GET_REQUEST', { url })

      return data.job_types
    },
    async getData () {
      try {
        this.loading = true
        this.statuses = await this.$store.dispatch('GET_REQUEST', {
          url: 'objectInfo/contract_statuses'
        })

        // get job_types or contragent_job_types
        const jobTypesUrl = this.contract_id
          ? 'contragent_job_type'
          : 'job_type'

        this.jobTypes = await this.$store.dispatch('GET_REQUEST', {
          url: `page/${jobTypesUrl}`
        })
        const users = await this.getUsers()

        this.managers = this.getManagers(users)
        this.fieldManagers = await this.getFieldManagers()

        if (this.contract_id) {
          this.roadmaps = await this.$store.dispatch('GET_REQUEST', {
            url: `page/roadmap_act_cost_lag/${this.contract_id}`
          })
        }

        const fileTypes = await this.$store.dispatch('GET_REQUEST', {
          url: 'objectInfo/file_types'
        })
        this.fileTypes = fileTypes
          .filter(t => t.object_name === 'contracts')
          .sort((a, b) => a.index - b.index)

        if (!this.contract.id && !this.contract.mandatory_file_types) {
          this.contract.mandatory_file_types = this.fileTypes.map(t => t.id)
        }

        // set initial status
        if (!this.contract.contract_status_id && this.statuses[0]) {
          this.contract.contract_status_id = this.statuses[0].id
        }

        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    }
  },
  created () {
    this.getData()
  }
}
</script>

<style lang="less">
.editor-common-info {
  .ivu-select,
  .ivu-input,
  .ivu-date-picker {
    width: 320px;
  }

  .ivu-checkbox {
    margin-right: 4px;
  }

  &__status-row {
    display: flex;

    .ivu-input-wrapper {
      width: auto;
    }

    .ivu-input {
      width: 220px;
    }
  }

  &__status {
    .ivu-select,
    .ivu-input {
      width: 100%;
    }
  }

  .full-width-container {
    margin-top: 8px;

    .ivu-input {
      width: 100%;
    }
  }

  &__original {
    // margin-top: 24px;

    span {
      margin-right: 2px;
    }
  }
}
</style>
